export const sharedEnvironmentAcc = {
  production: false,
  name: 'Acceptanstest',
  bgcolor: 'green',
  fontcolor: 'white',
  showEnvironment: true,
  cookieDomain: '.vinnova.se',

  //Endpoints
  portalAdminUrl: 'https://e-admin.acc.vinnova.se/adminportal',
  nJobEngineUrl: 'https://e-admin.acc.vinnova.se/njobengine',
  notifyServiceApiUrl: 'https://notifiering.api.acc.vinnova.se',
  eadminUrl: 'https://e-admin.acc.vinnova.se',
  sprakHanteringApiUrl: 'https://sprakresurser.api.acc.vinnova.se/api',
  bedomarpoolAdminUrl: 'https://bedomarpooladmin.acc.vinnova.se',
  oregApiUrl: 'https://organisationsregistret.api.acc.vinnova.se/api',
  bpoolApiUrl: 'https://bedomarpooladmin.api.acc.vinnova.se',
  effektaUrl: 'https://effekta.acc.vinnova.se',
  formBuilderApiUrl: 'https://formularbyggare.api.acc.vinnova.se',
  formBuilderUrl: 'https://formularbyggare.acc.vinnova.se',
  formAdmin: 'https://formularadmin.api.acc.vinnova.se',
  etjansterCommonApiUrl: 'https://etjanster.api.acc.vinnova.se',
  etjansterCommonUrl: 'https://etjanster.acc.vinnova.se',
  bpUrl: 'https://bedomningsportal.acc.vinnova.se',
  bpApiUrl: 'https://bedomningsportal.api.acc.vinnova.se/api',
  enkatRegisterUrl: 'https://projekt.acc.vinnova.se/enkatregister',
  oregUrl: 'https://projekt.acc.vinnova.se/oreg',
  healthMonitorApiUrl: 'https://monitorering.api.acc.vinnova.se',
  ansokanApiUrl: 'https://ansok.api.acc.vinnova.se',
  ansokanUrl: 'https://ansok.acc.vinnova.se',
  forhandsgranskaApiUrl: 'https://forhandsgranska.api.acc.vinnova.se/api',
  forhandsgranskaUrl: 'https://forhandsgranska.acc.vinnova.se',
  utlysningsbyggareApiUrl: 'https://utlysningsbyggare.api.acc.vinnova.se/api',
  utlysningsbyggareUrl: 'https://utlysningsbyggare.acc.vinnova.se',
  projektUrl: 'https://projekt.acc.vinnova.se',
  logServiceApiUrl: 'https://loggservice.api.acc.vinnova.se',
  gatewayUrl: 'https://test.api.vinnova.se/acc',
  signeringApiUrl: 'https://signering.api.acc.vinnova.se/api',

  apimSubscriptionKey: '10191a594e334dbdbf4c280e36ec8a51',

  // Keys
  tinyMceApiKey: '3v8orrp96m8v7vwbg61c31rrhu3dffg5wi6rlluihkl56ot0',

  //ClientIds
  azureAd: {
    formBuilderClientId: '0e3ad57e-1254-4695-a993-92dcca132edd',
    formBuilderApiClientId: '19aeaa07-6761-4c59-9d15-77947626c768',
    formAdminApiClientId: '437bfa68-cfc6-472c-8452-dff5ff8ade06',
    etjansterCommonApiClientId: '2ab1d012-5736-48ac-a84b-1f0ff2b3a0d5',
    etjansterCommonApiScope: 'api://2ab1d012-5736-48ac-a84b-1f0ff2b3a0d5/all',
  },
  azureAdB2C: {
    tenant: 'vinnovab2cacc',
    authority:
      'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/',
    policies: {
      signUp: {
        name: 'B2C_1A_signup',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1A_signup',
      },
      sso: {
        name: 'B2C_1_signupsignin_sso',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1_signupandsignin_sso',
      },
      signInPhone: {
        name: 'B2C_1A_signin_phone',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1A_signin_phone',
      },
      profileEdit: {
        name: 'B2C_1_profileedit',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1_profileedit',
      },
      passwordChange: {
        name: 'B2C_1A_profile_edit_password_change',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1a_profile_edit_password_change',
      },
      changeSignInName: {
        name: 'B2C_1A_changesigninname',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1a_changesigninname',
      },
      signIn: {
        name: 'B2C_1A_signin',
        authority:
          'https://vinnovab2cacc.b2clogin.com/vinnovab2cacc.onmicrosoft.com/b2c_1A_signin',
      },
    },
    clientId: {
      etjansterCommonClientId: '9c37a8ba-7f60-4bd8-adde-631fa61ddab3',
      etjansterCommonApiClientId: '8c1c1531-350a-47b9-8fc6-c892f1dee142',
      ansokanClientId: 'd3b0d386-91b8-427a-b40b-7cdf164aa55a',
      ansokanApiClientId: '082b76db-3b19-4de4-b930-3b276e391b8d',
      bedomningsportalClientId: '29d358ec-8615-49af-bcb7-de11879837cb',
      bedomningsportalApiClientId: '16bb397f-cf91-4471-8ced-578d0f93e430',
      projektClientId: 'fa1d3df0-4927-421a-abb0-be1912d5c91d',
      projektApiClientId: '4ed6572d-5ec5-4029-81ba-53e06998686a',
      forhandsgranskaClientId: 'f3b523ed-ff89-4d3b-93df-ee4e0f5e9496',
      forhandsgranskaApiClientId: 'c483ca70-3a93-46d0-8a07-90fe25d73f81',
      enkatregisterApiClientId: 'fbb8fa59-7d8e-4da3-a959-76b3f9c3b462',
      oregApiClientId: 'aba2050a-ecd8-4d89-8ec6-70499bd6bf3f',
      signeraApiClientId: '98ed2446-4509-4376-b8cf-1ab83b2e4072',
    },
  },
  //Externa länkar
  externalLinks: {
    ansokanGuide: {
      sv: 'https://www.vinnova.se/sok-finansiering/sa-har-fyller-du-i-ansokan/',
      en: 'https://www.vinnova.se/en/apply-for-funding/how-to-complete-your-application/',
    },
    regler: {
      sv: 'https://www.vinnova.se/sok-finansiering/regler-for-finansiering/',
      en: 'https://www.vinnova.se/en/apply-for-funding/rules-for-our-funding/',
    },
    gdpr: {
      sv: 'https://www.vinnova.se/om-oss/vart-uppdrag/regler-som-styr-var-verksamhet/personuppgifter/',
      en: 'https://www.vinnova.se/en/about-us/our-mission/rules-that-govern-our-activities/how-we-handle-personal-data/',
    },
  },
  ga4MeasurementId: 'G-DJPY2PMYE7',
};
